<script>
    import { layoutMethods, gbitsEloadTopupMethods, gbitsEloadTopupComputed } from "@/state/helpers";
    import b2bAction from '@/views/pages/_version_2_/gbits/topup-request/action.vue';
    import Swal from "sweetalert2";

    /**
     * Eload b2b details component
     */
    export default {
        page: {
        title: "eLoad B2B Details"
        },
        components: {
            b2bAction,
        },
        computed: {
            ...gbitsEloadTopupComputed,
            requestStatus: {
                get(){
                    let status = "Requesting",
                        color = "#DC7512",
                        badgeTextColor = "#fff";
                    switch (this.eloadB2BRequestDetails?.status) {
                        case "approved":
                            status = "Top Up Completed"
                            color = "#508F30"
                            break;
                        case "rejected":
                            status = "Rejected"
                            color = "#AFAFAF"
                            badgeTextColor = "#AFAFAF"
                            break;
                        case "for_payment":
                            status = "For Payment"
                            color = "#F7CC53"
                            break;
                        case "expired_qrph":
                            status = "Expired QR"
                            color = "#831118"
                            break;
                        default:
                            break;
                    }
                    return { status, color, badgeTextColor, badgeBg: this.eloadB2BRequestDetails?.status === 'rejected' ? '#E6EAF1' : color }
                },
            }
        },
        data() {
            return {
                title: "eLoad B2B Details",
                refNo:null,
                userAccess: {
                    access: {
                        create: false,
                        read: false,
                        update: false,
                        delete: false,
                    }
                },
                isLightboxVisible: false,
                lightBoxImageUrl: "",
            };
        },
        methods: {
            ...layoutMethods,
            ...gbitsEloadTopupMethods,
            async fetchRequestDetails(){
                try {
                    await this.getEloadB2BRequestDetails({
                        refNo: this.refNo
                    });
                } catch (e) {
                    console.log("fetchRequestDetails error:", e);
                }
                // If not found and refNo is numeric (id), retry fetch by id
                if(this.$options.filters.isEmpty(this.eloadB2BRequestDetails)){
                    Swal.fire({
                        title: "Request Not Found",
                        text: "The topup request you are looking for does not exist.",
                        icon: "warning",
                        confirmButtonText: "OK",
                        buttonsStyling: false,
                        customClass: { confirmButton: "btn btn-primary" },
                    }).then(() => {
                        this.$router.push({ name: "GBITS Topup Requests" });
                    });
                }
            },
            backTo(){
                this.$router.push(
                    this.$route.query.redirectFrom || {
                        name: "GBITS Topup Requests"
                    }
                );
            },
            getPaymentMethod(method, isEwt) {
                if (method === "bank_deposit") return "Bank Deposit";
                if (method === "qrph") return "QRPH";
                if (method === "ewt" || isEwt == 1) return "EWT";
                return "--";
            },
            formatRequestId(item) {
                if (!item || !item.id) return "--";
                const date = item.deposit_date || item.created_at;
                if (!date) return item.id;
                const d = new Date(date);
                const yyyyMM = `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, '0')}`;
                const paddedId = String(item.id).padStart(5, '0');
                return `${yyyyMM}${paddedId}`;
            },
            viewImage(img){
                this.lightBoxImageUrl = img
                this.isLightboxVisible = true;
            }
        },
        async mounted(){
            this.clearRequestDetails();
            this.changeTitle({ title: "Topup Request Details" });
            this.changeBreadCrumb({
            breadCrumbs: [
                { text: "Peddlr", to: { name: "Home" } },
                { text: "GBITS Manager", to: { name: "" } },
                { text: "Request", to: { name: "GBITS Topup Requests" } },
                { text: "Details", to: { name: "" } },
            ],
            });
            this.refNo = this.$route.params.refNo;
            if (!this.refNo) {
              this.backTo();
              return;
            }
            try {
              await this.getTopupAccess()
                .then((access) => this.userAccess.access = access)
                .catch(() => {});
              await this.fetchRequestDetails();
            } catch (e) {
              console.log("Error loading details:", e);
            }
        }
    }
    
</script>
<style scoped>
    ul {list-style-type: none;} 
    ul li {margin: 10px 0px;}
    .custom-image-container{
        width: 60pt;  
        height: 30px; 
        overflow: hidden; 
        border: 1px solid #999;
        border-radius: 8px;
    }
    .custom-image-container img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .status-badge {
        font-size: 12px;
        font-weight: 600;
        color: #fff;
        padding: 7px 14px;
        border-radius: 20px;
        white-space: nowrap;
    }
</style>
<template>
  <div class="row"><!-- outer div-->
    <vue-easy-lightbox
        moveDisabled
        :visible="isLightboxVisible"
        :imgs="lightBoxImageUrl"
        @hide="isLightboxVisible = false"
    ></vue-easy-lightbox>
    <b-col sm="12" md="4">
        <b-card>
            <h4 class="border-bottom d-flex align-items-center pb-3">
                Merchant Details
                <span v-if="eloadB2BRequestDetails.status" class="status-badge ms-auto" :style="{ backgroundColor: requestStatus.badgeBg, color: requestStatus.badgeTextColor }">{{ requestStatus.status }}</span>
            </h4>
            <ul class="p-0">
                <li>
                    <span class="fw-semibold">Request ID:</span> {{ formatRequestId(eloadB2BRequestDetails) }}
                </li>
                <li>
                    <span class="fw-semibold">Request Date:</span> {{ eloadB2BRequestDetails.created_at | formatDate }}
                </li>
                <li>
                    <span class="fw-semibold">Account ID:</span> {{ eloadB2BRequestDetails.account_id | notEmpty}}
                </li>
                <li>
                    <span class="fw-semibold">Business Name:</span> {{ eloadB2BRequestDetails.businessName | notEmpty}}
                </li>
                <li>
                    <span class="fw-semibold">Merchant Name:</span> {{ eloadB2BRequestDetails.merchantName | notEmpty}} 
                </li>
            </ul>
            <h4 class="border-bottom mt-4 pb-3">{{ eloadB2BRequestDetails.status == "rejected" ? "Rejection":"Approval"}} Details</h4>
            <ul class="p-0">
                <li>
                    <span class="fw-semibold">Requested By:</span> {{ eloadB2BRequestDetails.requested_by | notEmpty}}
                </li>
                <li>
                    <span class="fw-semibold">Review By Finance:</span> {{ eloadB2BRequestDetails.approved_by | notEmpty}}
                </li>
                <li>
                    <span class="fw-semibold">Reviewed Date:</span> {{ eloadB2BRequestDetails.approved_at | formatDate  | notEmpty}}
                </li>
                <li class="d-flex align-items-center" v-if="eloadB2BRequestDetails.status == 'approved'">
                    <span class="fw-semibold me-2">Proof of Confirmation:</span>
                    <div v-if="eloadB2BRequestDetails.proof_of_confirmation" class="custom-image-container">
                        <img 
                        :src="eloadB2BRequestDetails.proof_of_confirmation" 
                        @click="viewImage(eloadB2BRequestDetails.proof_of_confirmation)" 
                        alt="Proof of confirmation" 
                        class="ms-2 c-pointer"
                        @error="(e) => e.target.src = require('@/assets/images/img-placeholder.png')"
                        >
                    </div>
                    <span v-else>--</span>
                </li>
                <li v-if="eloadB2BRequestDetails.status == 'rejected'">
                    <span class="fw-semibold">Reject Reason:</span> {{ eloadB2BRequestDetails.remarks | notEmpty}}
                </li>
            </ul>
        </b-card>
    </b-col>
    <b-col sm="12" md="8">
        <b-card>
            <h4 class="border-bottom pb-3">Payment Details</h4>
            <ul class="p-0">
                <li>
                    <span class="fw-semibold">Payment Reference Number:</span> {{ eloadB2BRequestDetails.reference_number | notEmpty}}
                </li>
                <li>
                    <span class="fw-semibold">Deposit Date:</span>
                    <span v-if="eloadB2BRequestDetails.payment_method === 'qrph' && eloadB2BRequestDetails.status !== 'approved'"> --</span>
                    <span v-else-if="eloadB2BRequestDetails.payment_method === 'qrph' && eloadB2BRequestDetails.status === 'approved'"> {{ eloadB2BRequestDetails.approved_at | formatDateOnly | notEmpty}}</span>
                    <span v-else> {{ eloadB2BRequestDetails.deposit_date | formatDateOnly | notEmpty}}</span>
                </li>
                <li>
                    <span class="fw-semibold">Sender Bank:</span> {{ eloadB2BRequestDetails.sender_bank_name | notEmpty}}
                </li>
                <li>
                    <span class="fw-semibold">Peddlr Bank Acount:</span> {{ eloadB2BRequestDetails.peddlr_bank_name | notEmpty}}
                </li>
                <li class="d-flex align-items-center">
                    <span class="fw-semibold me-2">Deposit Screenshot:</span> 
                    <div class="custom-image-container" v-if="eloadB2BRequestDetails?.deposit_ss_url">
                        <img 
                        :src="eloadB2BRequestDetails.deposit_ss_url" 
                        @click="viewImage(eloadB2BRequestDetails.deposit_ss_url)" 
                        alt="Deposit Screenshot" 
                        class="ms-2 c-pointer"
                        @error="(e) => e.target.src = require('@/assets/images/img-placeholder.png')"
                        >
                    </div>
                    <span v-else>--</span>
                </li>
                <li class="d-flex align-items-center" v-if="eloadB2BRequestDetails?.is_ewt == 1 && eloadB2BRequestDetails?.ewt_file">
                    <span class="fw-semibold me-2">BIR 2307 (EWT):</span> 
                    <a :href="eloadB2BRequestDetails.ewt_file" target="_blank" class="text-decoration-underline" style="color: #3967B8;">
                      View BIR 2307
                    </a>
                </li>
                <li>
                    <span class="fw-semibold">Deposit Amount:</span> PHP {{ eloadB2BRequestDetails.deposit_amount | numberWithCommas }}
                </li>
                <li v-if="eloadB2BRequestDetails?.is_ewt == 1">
                    <span class="fw-semibold">WHT Amount:</span> PHP {{ eloadB2BRequestDetails.ewt_amount | numberWithCommas }}
                </li>
                <li>
                    <span class="fw-semibold">Default Rebate:</span> {{ eloadB2BRequestDetails.rebate_percentage | notEmpty}}%
                </li>
                <li>
                    <span class="fw-semibold">Wallet Topup Amount:</span> PHP {{ eloadB2BRequestDetails.topup_amount | numberWithCommas }}
                </li>
                <li v-if="eloadB2BRequestDetails?.service_charge">
                    <span class="fw-semibold">Convenience Fee:</span> PHP {{ eloadB2BRequestDetails.service_charge | numberWithCommas }}
                </li>
                <li>
                    <span class="fw-semibold">Payment Method:</span> {{ getPaymentMethod(eloadB2BRequestDetails.payment_method, eloadB2BRequestDetails.is_ewt) }}
                </li>
                <li>
                    <span class="fw-semibold">Status:</span> <span class="fw-semibold" :style="{ color: requestStatus.color }">{{ requestStatus.status }}</span>
                </li>
                <li class="d-flex align-items-center">
                    <span class="fw-semibold me-2">Remarks Purpose:</span>  {{ eloadB2BRequestDetails.remarks_reason | notEmpty }}
                </li>
            </ul>

            <b2b-action
               view = "details"
               :requestData = eloadB2BRequestDetails
               :userAccess = userAccess.access
               @reload = "fetchRequestDetails()"
            />

            <div class="text-end">
                <b-button variant="light" @click="backTo">Close</b-button>
            </div>
        </b-card>
    </b-col>
  </div> <!-- end of outer div-->
</template>
<!-- 
{{ view }}
{{ requestData }} -->